import { Types } from './actions';

export const INITIAL_STATE = [];

export default function categorias(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.SUCCESS: {
      return [...action.payload];
    }
    case Types.FAILURE: {
      return [...INITIAL_STATE];
    }
    default:
      return state;
  }
}
